import { render } from "./LoginIdeasComponent.vue?vue&type=template&id=4e2487fc&scoped=true"
import script from "./LoginIdeasComponent.vue?vue&type=script&lang=js"
export * from "./LoginIdeasComponent.vue?vue&type=script&lang=js"

import "./LoginIdeasComponent.vue?vue&type=style&index=0&id=4e2487fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2487fc"]])

export default __exports__